import { render, staticRenderFns } from "./MyFavoriteMaid.vue?vue&type=template&id=53e2280c"
import script from "./MyFavoriteMaid.vue?vue&type=script&lang=js"
export * from "./MyFavoriteMaid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports